import { InputBase, styled } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { theme } from '../theme/mui-theme';

export const StyledContainer = styled('div')({
	'--input-height': '48px',
	display: 'flex',
	height: 'var(--input-height)',
	columnGap: theme.spacing(1),
	alignItems: 'center',
	border: '1px solid rgba(0, 0, 0, 0.12)',
	borderRadius: 'var(--input-height)',
	paddingLeft: theme.spacing(2),
	paddingRight: theme.spacing(2)
});

export const StyledIcon = styled(SearchIcon)({
	color: 'rgba(0, 0, 0, 0.6)'
});

export const StyledInput = styled(InputBase)({
	flexGrow: 1
});
